import { Link } from "react-router-dom";
import { MapPin, Sparkles } from "lucide-react";
import { photoUrl, lastSeenInfo } from "@/lib/api";

export const HostessCard = ({ h, index = 0 }) => {
  const p = h.profile || {};
  const cover = p.photos?.[0];
  const seen = lastSeenInfo(h.last_seen);
  return (
    <Link to={`/hostess/${h.id}`} className="group block fade-up" style={{ animationDelay: `${index * 70}ms` }} data-testid={`hostess-card-${h.id}`}>
      <div className="relative aspect-[3/4] overflow-hidden bg-[#181B20] border border-white/5 group-hover:border-[#D4AF37]/40 transition-colors duration-500">
        {cover ? (
          <img src={photoUrl(cover)} alt={h.name} className="w-full h-full object-cover grayscale-[35%] group-hover:grayscale-0 group-hover:scale-105 transition-[transform,filter] duration-700" />
        ) : (
          <div className="w-full h-full flex items-center justify-center font-serif text-6xl text-neutral-700">{h.name[0]}</div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0C0E] via-[#0B0C0E]/10 to-transparent" />
        <div className="absolute top-4 left-4 flex flex-wrap gap-1.5">
          {h.sponsored && <span className="text-[10px] uppercase tracking-[0.15em] px-2 py-1 bg-[#D4AF37] text-[#0B0C0E] font-semibold flex items-center gap-1" data-testid={`hostess-card-sponsored-${h.id}`}><Sparkles className="w-3 h-3" />In evidenza</span>}
          {(p.categories || []).slice(0, 2).map((c) => (
            <span key={c} className="text-[10px] uppercase tracking-[0.15em] px-2 py-1 bg-[#0B0C0E]/70 backdrop-blur border border-white/10 text-neutral-200">{c}</span>
          ))}
        </div>
        <div className="absolute bottom-0 inset-x-0 p-5">
          <h3 className="font-serif text-2xl leading-tight">{h.name}</h3>
          <div className="flex items-center justify-between mt-2 text-xs text-neutral-400">
            <span className="flex items-center gap-1"><MapPin className="w-3 h-3 text-[#D4AF37]" />{p.city || "—"}</span>
            <span className="font-mono">{p.height ? `${p.height} cm` : ""}</span>
          </div>
          {seen.label && (
            <p className="flex items-center gap-1.5 mt-2 text-[11px] text-neutral-400" data-testid={`hostess-card-online-${h.id}`}>
              <span className={`w-1.5 h-1.5 rounded-full ${seen.online ? "bg-emerald-400 shadow-[0_0_6px_rgba(52,211,153,0.8)]" : "bg-neutral-600"}`} />{seen.label}
            </p>
          )}
        </div>
      </div>
    </Link>
  );
};
